import { toneNumbersPinyinText } from "@-/dev.improve.haniverse.database.schemas._lib.types.pinyin";
import { crudTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * A pronunciation card is identified by `(grapheme, pinyin)`, and its row ids are derived from the
 * pair (`deriveGraphemePronunciationCardRowIds`), so two devices that create the card before they
 * sync create the same rows. That is why no unique index guards the pair or `user_card_id`: sync
 * cannot resolve a unique conflict, so the duplicate is made impossible instead.
 */
export const userGraphemePronunciationCardTable = crudTable(
  "user_grapheme_pronunciation_card",
  {
    // A parent id, not a FOREIGN KEY: see `ACTOR_TABLE_PARENTS` (the cloud copy would enforce one).
    userCardId: text("user_card_id").notNull(),
    /** User-authored pinyin mnemonic; null means use catalog default */
    description: text("description"),
    grapheme: text("grapheme").notNull(),
    pinyin: toneNumbersPinyinText("pinyin").notNull(),
  },
  // `userCardId` backs the `userCard.userGraphemePronunciationCard` relation join; `grapheme`
  // backs the `findFirst({ where: { grapheme, pinyin } })` upsert/reset lookups.
  (table) => [
    index("user_grapheme_pronunciation_card_grapheme_idx").on(table.grapheme),
    index("user_grapheme_pronunciation_card_user_card_id_idx").on(table.userCardId),
  ],
);

export type UserGraphemePronunciationCard = typeof userGraphemePronunciationCardTable.$inferSelect;
